import { render } from "./TriggerButton.vue?vue&type=template&id=f968fda8"
import script from "./TriggerButton.vue?vue&type=script&lang=ts"
export * from "./TriggerButton.vue?vue&type=script&lang=ts"
script.render = render

export default script